document.addEventListener('DOMContentLoaded', function () {
  if (window.Shopify?.designMode) {
    return;
  }
  const CLEAR_EN_MANUAL_BLOCKED = 'clear_suffix_blocked';
  const FIRST_VISIT_KEY = 'market_auto_selected';

  const lenguageSelectorFormElement = document.querySelector('[data-js-language-select-form]');
  const languageSelectorCountryInput = lenguageSelectorFormElement.querySelector('[data-js-country-code]');
  const languageSelectorElement = lenguageSelectorFormElement.querySelector('[data-js-language-select]');
  const currentCountryData = lenguageSelectorFormElement.querySelector('[data-js-country-code]').dataset.curentCountry;

  const popoutToggleButtons = document.querySelectorAll('[data-popout-toggle]');

  const languageButtons = document.querySelectorAll('[data-popout-option-button]');

  window.useRedirect = true;

  function clearSuffix() {
    const { origin, pathname, search, hash } = window.location;

    if (pathname === '/en' || pathname.startsWith('/en/')) {
      window.useRedirect = false;
      localStorage.setItem(FIRST_VISIT_KEY, 'false')
      const newPath = pathname.replace(/^\/en/, '') || '/';
      window.location.replace(origin + newPath + search + hash);
      return;
    }
  }

  if (localStorage.getItem(CLEAR_EN_MANUAL_BLOCKED) != 'true') {
    clearSuffix();
  }

  function setButtonText(text) {
    popoutToggleButtons.forEach((button) => {
      button.textContent = `${text}`
    })
  }

  if (window.useRedirect) {
    function setUserLocation() {
      let buttonText = ''
      fetch("https://ipinfo.io/json")
        .then((res) => res.json())
        .then((data) => {
          console.log("Country Code:", data.country);
          languageSelectorCountryInput.value = `${data.country}`
          if (data.country != 'FR' && localStorage.getItem(FIRST_VISIT_KEY) == 'false' || !localStorage.getItem(FIRST_VISIT_KEY)) {
            localStorage.setItem(FIRST_VISIT_KEY, 'true');
            lenguageSelectorFormElement.submit();
            return
          } 
          if (data.country == 'FR' && !window.location.pathname.startsWith('/en')) {
            buttonText = 'Français'
            languageSelectorElement.value = 'fr'
            setButtonText(buttonText)
          }
          else if (data.country == 'FR' && currentCountryData != 'US' && !window.location.pathname.startsWith('/en') || window.location.pathname.startsWith('/fr-')) {
            buttonText = 'Français'
            languageSelectorElement.value = 'fr'
            setButtonText(buttonText)
          }
          else if (data.country == 'FR' && window.location.pathname.startsWith('/en')) {
            buttonText = 'English'
            languageSelectorElement.value = 'en'
            setButtonText(buttonText)
          } else {
            buttonText = 'English'
            setButtonText(buttonText)
          }
        })  
        .catch((error) => console.error("Error fetching IP info:", error));
    }

    if (lenguageSelectorFormElement) {
      setUserLocation()
    }

    languageButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();

        const selectedLang = this.dataset.lang;

        if (currentCountryData == 'US' && languageSelectorCountryInput.value != 'FR' && !window.location.pathname.startsWith('/fr-us')) {
          languageSelectorElement.value = 'fr'
        }
        else if (currentCountryData == 'US' && window.location.pathname.startsWith('/fr-us')) {
          languageSelectorElement.value = 'en'
        }
        else if (languageSelectorCountryInput.value == 'FR' && !window.location.pathname.startsWith('/en')) {
          languageSelectorElement.value = 'en'
          localStorage.setItem(CLEAR_EN_MANUAL_BLOCKED, 'true');
        }
        else if (languageSelectorCountryInput.value == 'FR' && window.location.pathname.startsWith('/en')) {
          languageSelectorElement.value = 'fr'
          localStorage.setItem(CLEAR_EN_MANUAL_BLOCKED, 'false');
        }
        else if (currentCountryData == 'FR' && window.location.pathname.startsWith('/en-us')) {
          languageSelectorCountryInput.value = 'FR'
          languageSelectorElement.value = 'fr'
        } else {
          languageSelectorElement.value = selectedLang
          if (selectedLang == 'en') {
            buttonText = 'English'
            setButtonText(buttonText)
          } else {
            buttonText = 'Français'
            setButtonText(buttonText)
          }
        }
        lenguageSelectorFormElement.submit();
      })
    })
  }
})